import { User } from 'src/models/user';

export interface AdminHeaderIdentity {
  name?: string;
  companyName?: string;
}

export const getAdminHeaderIdentity = (user: User): AdminHeaderIdentity => {
  const isChildAdmin = !user.is_root && user.role?.role_type === 'admin';

  return {
    name: user.name,
    companyName: isChildAdmin
      ? (user.parent?.company_name ?? user.company_name)
      : user.company_name,
  };
};
